import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { TagManagerService } from '@services/tag-manager.service';
import { GoogleTagManagerEventEnum } from 'src/app/enums/GoogleTagManagerEvent.enum';
import { GoogleTagManagerModel } from 'src/app/models/google-tag-manager.model';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-alert-loading',
    templateUrl: './alert-loading.component.html',
    styleUrls: ['./alert-loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class AlertLoadingComponent implements OnChanges {

  @Input() alertLoading: boolean = false;
  @Input() sourceScreen: string = '';
  @Input() statusUpload: any = 0;
  @Input() statusFase: number = 0;
  @Input() showOverlay = true;

  constructor(private readonly tagManagerService: TagManagerService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.alertLoading?.currentValue) {
      this.addTagManagerScreenView();
    }
  }

  addTagManagerScreenView() {
    const model = this.addTagManager(GoogleTagManagerEventEnum.noInteraction, 'modal:message:view', 'carregando-seu-arquivo');
    this.tagManagerService.pushTag(model);
  }

  private addTagManager(event: GoogleTagManagerEventEnum, elementType: string, elementContent: string): GoogleTagManagerModel {
    const section = this.sourceScreen === '' ? '' : this.sourceScreen.split(':')[0];
    let model: GoogleTagManagerModel = new GoogleTagManagerModel();
    model.event = event;
    model.element_type = elementType;
    model.element_content = `none:${elementContent}:none`;
    model.section_app = section;
    model.screen_name = this.sourceScreen;
    model.screen_type = 'pagina';
    return model;
  }
}
